import { Box } from "@chakra-ui/react";
import { MapContainer,TileLayer,Marker,Popup } from "react-leaflet";


export default function  ({ height = "700px" })  {
  const center = [48.054770, 22.040316];

  return (
    <Box width="90%" height={height}>
      <MapContainer
        center={center}
        zoom={16}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={center}>
          <Popup>Laskod, Szabadság út 31.</Popup>
        </Marker>
      </MapContainer>
    </Box>
  );
};


